export default {
      id: "icon-check-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "icons.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }